import { FormsCheckbox, Text } from '@viapeople/components'
import type { FormComponent } from '../types'
import type { BaseReportsProps } from './types'

export const CheckboxReports = ({ component, reports }: BaseReportsProps) => {
	// Suppress label in reports since report.label is already shown
	const componentWithoutLabel = Object.assign({}, component, {
		custom: Object.assign({}, component.custom || {}, {
			labelWeight: 'hidden' as const,
		}),
	}) as FormComponent

	return (
		<div className='flex flex-col self-start gap-6'>
			{reports.map((report, reportIndex) => (
				<div key={report.label} className='print-keep-together'>
					<div className='mb-2'>
						<Text variant='small' weight='semibold' className='text-neutral-700'>
							{report.label}
						</Text>
					</div>

					<div className='flex flex-col gap-4'>
						{report.submissions.map((submission) => (
							<div key={submission.label} className='flex flex-col gap-2'>
								<Text variant='xsmall' weight='semibold' className='text-neutral-600'>
									{submission.label}
								</Text>
								<FormsCheckbox
									component={componentWithoutLabel}
									checked={submission.value === 'true'}
									onChange={() => {}}
									readOnly={true}
								/>
							</div>
						))}
					</div>

					{reportIndex < reports.length - 1 && <div className='w-full h-px bg-neutral-200 my-6' />}
				</div>
			))}
		</div>
	)
}
